import { trimJoinedStringWhitespace } from '../../core/util';
import { maskSsnForDisplay } from '../PersonalInformationSection/util';

export const personalInformationLine = customer => {
  const { name, citizenship, taxID, dob } = customer || {};
  const { firstName, middleName = '', lastName } = name || {};

  // Midle initial might also be in there...
  const fullName = [firstName, middleName, lastName].join(' ');

  return [
    trimJoinedStringWhitespace(fullName),
    dob,
    {
      US_CITIZEN: 'U.S. Citizen',
      RESIDENT_ALIEN: 'U.S. Resident Alien'
    }[citizenship] || citizenship,
    maskSsnForDisplay(taxID)
  ]
    .filter(item => item)
    .join(' / ');
};
